var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuilding = function SvgBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7H3a1 1 0 0 0-1 1v14h9V8a1 1 0 0 0-1-1ZM6 20H4v-2h2v2Zm0-3H4v-2h2v2Zm0-3H4v-2h2v2Zm0-3H4V9h2v2Zm3 9H7v-2h2v2Zm0-3H7v-2h2v2Zm0-3H7v-2h2v2Zm0-3H7V9h2v2Z",
    fill: "rgb(var(--tw-color-primary-200))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.406 5.736 13 2v20h9V6.65a1 1 0 0 0-.588-.911l-.006-.003ZM20 18h-5v-2h5v2Zm0-4h-5v-2h5v2Zm0-4h-5V8h5v2Z",
    fill: "rgb(var(--tw-color-primary-900))"
  })));
};
export default SvgBuilding;